import AcceptedPaymentMethods from '@flowio/accepted-payment-methods';

const storage = require('@flowio/storage');
const session = require('@flowio/session');
const optin = require('@flowio/optin');
const countryPicker = require('@flowio/country-picker/lib/index');
const assign = require('lodash/assign');
const get = require('lodash/get');
const config = require('./config');
const init = require('./init');
const cart = require('./cart');
const checkout = require('./checkout');
const orders = require('./orders');
const variants = require('./variants').default;
const text = require('./text');
const experience = require('./experience');
const events = require('./events');
const cache = require('./cache');
const format = require('./format');
const queue = require('./queue');
const experiments = require('./experiments');
const updateSession = require('./utilities/update-session');
const syncCartAttributes = require('./utilities/sync-cart-attributes');
const { getCart } = require('./cart_unified/cart-unified');
const features = require('./features');
const internalLocalize = require('./localize');
const { isEnabled: isBlazeEnabled } = require('./blaze');

const acceptedPaymentMethods = new AcceptedPaymentMethods();

function getPublicKey() {
  return config.FLOW_PUBLIC_KEY;
}

function localize(options = {}) {
  return internalLocalize(options);
}

function onSessionUpdateCallback(onSessionUpdate, status, sess) {
  if (onSessionUpdate) {
    onSessionUpdate(status, sess);
  } else {
    window.location.reload();
  }
}

function createCountryPicker(options = {}) {
  const countries = storage.session.get('countries') || storage.memory.get('countries');
  const onSessionUpdateOption = options.onSessionUpdate;

  const onSessionUpdate = (status, sess) => {
    const geoObj = sess.geo;
    syncCartAttributes(sess, getCart()).then(() => {
      Flow.cart.setGeo(
        {
          country: get(geoObj, 'country.iso_3166_3'),
          currency: get(geoObj, 'currency.iso_4217_3'),
          language: get(geoObj, 'language.iso_639_2'),
          locale: get(geoObj, 'locale.id'),
          experience: get(sess, 'experience.key'),
        },
        {
          success: () => {
            onSessionUpdateCallback(onSessionUpdateOption, status, sess);
          },
          error: () => {
            onSessionUpdateCallback(onSessionUpdateOption, status, sess);
          },
        },
      );
    });
  };
  // We want to always override the onSessionUpdate from the options with the one we created
  // Because we call the function passed into the options in the callback.
  if (countries) {
    countryPicker.createCountryPicker({
      countries,
      ...options,
      onSessionUpdate,
    });
  } else {
    countryPicker.createCountryPicker({
      ...options,
      onSessionUpdate,
    });
  }
}

// Expose beacon on the lowercase flow.* object as if beacon were installed natively
if (!get(window, 'flow')) {
  window.flow = {};
}

// TODO: Check Shopify client sites for usage of flow.beacon

// if (!get(window, 'flow.beacon')) {
//   window.flow.beacon = beaconIndex;
// }

if (!get(window, 'flow.countryPicker')) {
  window.flow.countryPicker = assign({}, countryPicker, { createCountryPicker });
}

// TODO: isBlazeEnabled is defined here to avoid circular reference.
features.isBlazeEnabled = isBlazeEnabled;

const beaconStub = {
  /*
  Leaving a noop beacon stub in place so as not to raise any errors on clients
  websites that may still be calling some of these methods.
  */
  processEvent: () => {},
  trackEvent: () => {},
  trackSessionUpserted: () => {},
  trackSessionAttribution: () => {},
  trackPageview: () => {},
  trackError: () => {},
};

module.exports = {
  init,
  set: queue.set,
  q: get(window, 'Flow.q', []),

  // Core
  beacon: beaconStub,
  cart,
  checkout,
  cache,
  variants,
  text,
  format,
  experiments,
  session,
  features,
  orders,

  // functions
  getCountries: experience.getCountries,
  getCountry: experience.getCountry,
  setCountry: experience.setCountry,
  getExperience: experience.getExperience,
  getLocalizedVariants(...args) {
    variants.getMapByExperience(...args);
  },
  getResultForKey: optin.getResultForKey,
  updateSession,
  localize,

  // Events
  on: events.on,
  off: events.off,
  once: events.once,
  paymentMethods: {
    renderAccepted: acceptedPaymentMethods.forceRender,
  },
  triggerEvent: events.trigger,
  removeAllEvents: events.removeAll,
  events: {
    constants: events.constants,
    resetPreviouslyTriggered: events.resetPreviouslyTriggered,
  },

  // setup / configuration properties
  initialized: false,
  getPublicKey,
};



// WEBPACK FOOTER //
// ./static/js/v0/flow.js